import { atom } from "recoil";
import { appLockApi } from "../api/appLockApi";

// 서버에 PIN이 설정되어 있음을 나타내는 placeholder
export const PIN_SET_PLACEHOLDER = "__PIN_SET__";

/**
 * 앱 잠금 활성화 여부 (boolean) - 서버 상태로 초기화
 */
export const appLockEnabledAtom = atom<boolean>({
  key: "appLockEnabledAtom",
  default: false,
  effects: [({ setSelf }) => {
    if (typeof window === "undefined") return;
    appLockApi
      .get()
      .then((settings) => setSelf(settings.isEnabled))
      .catch(() => {/* ignore */});
  }],
});

/**
 * PIN 해시 (서버에는 원문이 아닌 해시만 저장됨). 클라이언트에서는 실제 해시를 저장하지 않고 존재 여부만 placeholder로 표시.
 * 설정되지 않았으면 null
 */
export const appLockPinHashAtom = atom<string | null>({
  key: "appLockPinHashAtom",
  default: null,
  effects: [({ setSelf }) => {
    if (typeof window === "undefined") return;
    appLockApi
      .get()
      .then((settings) => setSelf(settings.hasPin ? PIN_SET_PLACEHOLDER : null))
      .catch(() => {/* ignore */});
  }],
});

/**
 * 생체 인증 사용 여부 (boolean) - 서버(API) 상태와 연동됨
 */
export const appBiometricEnabledAtom = atom<boolean>({
  key: "appBiometricEnabledAtom",
  default: false,
  effects: [({ setSelf }) => {
    if (typeof window === "undefined") return;
    appLockApi
      .get()
      .then((settings) => setSelf(!!settings.isBiometricEnabled))
      .catch(() => {/* ignore */});
  }],
});
